<template>
    <v-navigation-drawer
        :value="value"
        app
        dark
        color="primary"
        width="248"
        @input="$emit('input', $event)"
    >
        <router-link to="/" class="logo-link">
            <v-img src="@/assets/LOGOPARON 2023.svg" contain max-height="64" />
        </router-link>
        <v-divider class="mx-4" />
        <v-list nav dense class="px-2">
            <template v-for="section of visibleSections">
                <v-subheader :key="`header-${section.title}`" class="nav-subheader">{{ section.title }}</v-subheader>
                <v-list-item
                    v-for="route of section.routes"
                    :key="route.to"
                    :to="route.to"
                    :exact="route.to === '/'"
                    active-class="nav-item--active"
                    link
                >
                    <v-list-item-icon>
                        <v-icon>mdi-{{ route.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ route.title }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    const ADMIN = ['admin']
    const ALL = ['admin', 'dealer']

    export default {
        name: 'Sidebar',
        props: {
            value: {
                type: Boolean,
                default: null
            }
        },
        data() {
            return {
                sections: [
                    {
                        title: 'Overview',
                        routes: [
                            { title: 'Dashboard', to: '/', icon: 'view-dashboard-outline', roles: ALL }
                        ]
                    },
                    {
                        title: 'Members',
                        routes: [
                            { title: 'Members', to: '/members', icon: 'account-multiple-outline', roles: ALL },
                            { title: 'Cards', to: '/cards', icon: 'card-account-details-outline', roles: ADMIN },
                            { title: 'Vouchers', to: '/vouchers', icon: 'ticket-percent-outline', roles: ADMIN },
                            { title: 'Transactions', to: '/transactions', icon: 'receipt', roles: ALL }
                        ]
                    },
                    {
                        title: 'Network',
                        routes: [
                            { title: 'Partners', to: '/partners', icon: 'storefront-outline', roles: ALL },
                            { title: 'Offers', to: '/offers', icon: 'sale', roles: ADMIN },
                            { title: 'Teams', to: '/teams', icon: 'account-group-outline', roles: ALL },
                            { title: 'Dealers', to: '/dealers', icon: 'handshake-outline', roles: ADMIN }
                        ]
                    },
                    {
                        title: 'Content',
                        routes: [
                            { title: 'Articles', to: '/articles', icon: 'newspaper-variant-outline', roles: ADMIN },
                            { title: 'Promo', to: '/promos', icon: 'bullhorn-outline', roles: ADMIN },
                            { title: 'About Us', to: '/about-us', icon: 'information-outline', roles: ADMIN }
                        ]
                    },
                    {
                        title: 'Administration',
                        routes: [
                            { title: 'Users', to: '/users', icon: 'account-key-outline', roles: ADMIN }
                        ]
                    }
                ]
            }
        },
        computed: {
            userRole() {
                const user = this.$store.getters.currentUser
                return user && user.role
            },
            visibleSections() {
                return this.sections
                    .map(section => ({ ...section, routes: section.routes.filter(route => route.roles.includes(this.userRole)) }))
                    .filter(section => section.routes.length > 0)
            }
        }
    }
</script>

<style scoped>
.logo-link {
    display: block;
    padding: 20px 24px 16px;
}

.nav-subheader {
    height: 32px;
    margin-top: 8px;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    opacity: 0.6;
}

.nav-item--active {
    background-color: rgba(255, 255, 255, 0.14);
}

.nav-item--active::before {
    opacity: 0 !important;
}
</style>
